import { Button, Flex, Select, useToast } from "@chakra-ui/react"
import { useEffect, useState } from "react"
import { useEditConfirmacaoCompra } from "../../../contexts/EditConfirmacaoCompraProvider"
import { Card } from "../Card"
import { useMutation, useQuery, useQueryClient } from "react-query"
import { listarEmpresas, updateEnterprises } from "../requests"

export function EnterpriseStep({ partner, payment, refetch }) {

  const { data } = useQuery({
    queryFn: listarEmpresas,
    queryKey: "listar-empresas",
    refetchOnWindowFocus: false,
    staleTime: 1000 * 60 * 60 * 24,
  })

  const toast = useToast({
    position: "top-right",
  })


  const queryClient = useQueryClient()

  const { mutateAsync, isLoading } = useMutation({
    mutationFn: ({ codigo_empresa, numero_nota }) => updateEnterprises(codigo_empresa, numero_nota),
    mutationKey: 'update-enterprises',
    onSuccess: () => {
      queryClient.invalidateQueries('get-values')
      refetch()
      toast({
        title: "Empresa atualizada com sucesso",
        status: "success",
        duration: 3000,
      })
    },
    onError: (error) => {
      toast({
        title: "Ocorreu um erro ao atualizar a empresa",
        status: "error",
        duration: 3000,
      })
    },
  })

  async function handleUpdateEnterprises(codEmp, NUNOTA) {
    await mutateAsync({ codigo_empresa: codEmp, numero_nota: NUNOTA })
  }

  const [codEmp, setCodEmp] = useState("")

  return (
    <Flex flexDir="column" height="100%">
      <Card
        title="INNOVATION BRINDES"
        razaoSocial={partner?.emp_razao_social}
        cnpj={partner?.emp_cnpj}
        ie={partner?.emp_ie}
      />
      <Flex maxW="300px" mb="1rem" ml="1rem" marginTop="auto">
        <Select placeholder="Selecione a empresa" onChange={(e) => setCodEmp(e.target.value)}>
          {data?.map((emp) => (
            <option key={emp.nome_empresa} value={emp.codigo_empresa}>
              {emp.nome_empresa}
            </option>
          ))}
        </Select>

        <Button ml="1rem" onClick={() => handleUpdateEnterprises(codEmp, payment.NUNOTA)} isLoading={isLoading} isDisabled={isLoading}>
          Atualizar
        </Button>
      </Flex>
    </Flex>
  )
}
